import React from 'react';
import { FilterContextType } from './type';

export const FilterContext = React.createContext<FilterContextType>({
  filterVal: {},
  filterLoading: true,
  setFilterVal: () => { }
});
FilterContext.displayName = 'FilterContext';

// 1、onSuccess、onComplete、apiFail 是否只需要onSuccess就可以了：
// 每次api请求成功后，传递对应的接口或者组件（key）到refresh组件，然后在refresh组件中判断是否刷新成功
export const RefreshContext = React.createContext({
  // 触发刷新的状态
  forceRefresh: false,
  // 收集刷新的api，service层调用，参数：api名称,或则组件名称等唯一标识
  apiCollect: (_name: string): void => { },
  // api 请求成功回调，service层调用，参数：api名称
  apiSuccess: (_name: string): void => { },
  // api 请求失败回调, service层调用，参数：请求失败的接口名称；  todo： 是否需要传入失败数据
  apiFail: (_name: string): void => { },
  // 派发刷新
  dispatchRefresh: (_val: boolean) => { },
  // 重置组件内部状态
  reset: (): void => { },
});

RefreshContext.displayName = 'RefreshContext';
